/**
 * Die Tagesaufnahme meldet dem Server ihren Start. (23.09.2026, Ticket 2438)
 *
 * Albert, 16.09.: *„Jetzt habe ich eine halbe Stunde gesprochen und ich
 * gemerkt, dass das Handy gar nicht aufnimmt."* Der Stille-Wächter am
 * Server kannte eine Sitzung bis heute erst ab ihrem ersten Häppchen. Am
 * 22.09. lief eine Aufnahme ab etwa 22:29, das erste Häppchen kam um
 * 22:46:01 — siebzehn Minuten, in denen niemand warnen konnte.
 *
 * Hier sagt die App dem Server: „ab jetzt kommt Ton". Kommt dann eine
 * Viertelstunde lang keiner, geht derselbe Push raus wie bei einer
 * verstummten Sitzung (server/recorder-reaper.ts).
 *
 * ⚠️ Der Zustand allein genügt NICHT als Auslöser. Am 22.09. endete um
 *    22:29:00 eine Sitzung (puls-abriss) und die native Seite begann sofort
 *    die nächste — während die Seite schlief. Beim Aufwachen stand vorher
 *    wie nachher „nimmt auf"; nur der Beginn (`startedAt`) war ein anderer.
 *    Darum zählt auch ein neuer Beginn bei gleichem Zustand.
 *
 * ⚠️ Nur melden, wenn sich etwas ändert. Der Abgleich läuft alle 15 bis
 *    60 Sekunden; je Abgleich eine Anfrage wäre die Flut, gegen die der
 *    Akku-Umbau vom 31.07. gebaut wurde.
 */

interface LaufStand {
  /** Tagesaufnahme lebt: nimmt auf, pausiert, schliesst ab oder ist gewollt. */
  laeuft: boolean;
  /** Beginn laut nativem Rekorder in ms, 0 wenn keiner bekannt. */
  startedAt: number;
}

/**
 * Was jetzt zu melden ist: `true` (Lauf beginnt), `false` (Lauf endet)
 * oder `null` (nichts Neues). Rein, damit die Abwägung prüfbar ist.
 */
export function laufMeldung(
  vorher: LaufStand | null,
  jetzt: LaufStand,
): boolean | null {
  if (jetzt.laeuft) {
    if (!vorher?.laeuft) return true;
    /*
     * Neuer Beginn bei gleichem Zustand — der Fall vom 22.09. (siehe oben).
     * Auch ein Fortsetzen verschiebt den nativen Beginn um die Pausendauer
     * und meldet sich damit; harmlos, denn der Server behält eine schon
     * liegende Marke, und das nächste Häppchen löscht sie.
     */
    if (jetzt.startedAt > 0 && jetzt.startedAt !== vorher.startedAt) return true;
    return null;
  }
  return vorher?.laeuft ? false : null;
}

let gemeldet: LaufStand | null = null;

/** Nur für Tests. */
export function _laufZuruecksetzen(): void {
  gemeldet = null;
}

/** Den Stand melden, falls er etwas Neues sagt. Wirft nie. */
export function meldeAufnahmeLauf(jetzt: LaufStand): void {
  const m = laufMeldung(gemeldet, jetzt);
  gemeldet = jetzt;
  if (m === null) return;
  try {
    void fetch("/api/recorder/lauf", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      keepalive: true,
      body: JSON.stringify({ laeuft: m }),
    }).catch(() => undefined);
  } catch {
    /* Eine Meldung ist nie wichtiger als die Aufnahme. */
  }
}
